import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlReceita = '/service/contabilidade/transparencia/despesa/'

class ExerciciosOperacoesDespesasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getExercicios() {
        return this.conex.get(urlReceita + 'exerciciosDespesasOperacoes/')
    }
}

export default ExerciciosOperacoesDespesasService
